/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingCategoryDimensionRowData
 */
export interface AdvertisingCategoryDimensionRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    dimension?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    campaignCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    impressions?: number;
    /**
     * 
     * @type {AdvertisingCategoryDimensionRowDataFinanceScopeEnum}
     * @memberof AdvertisingCategoryDimensionRowData
     */
    financeScope?: AdvertisingCategoryDimensionRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const AdvertisingCategoryDimensionRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingCategoryDimensionRowDataFinanceScopeEnum = typeof AdvertisingCategoryDimensionRowDataFinanceScopeEnum[keyof typeof AdvertisingCategoryDimensionRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingCategoryDimensionRowData interface.
 */
export function instanceOfAdvertisingCategoryDimensionRowData(value: object): value is AdvertisingCategoryDimensionRowData {
    return true;
}

export function AdvertisingCategoryDimensionRowDataFromJSON(json: any): AdvertisingCategoryDimensionRowData {
    return AdvertisingCategoryDimensionRowDataFromJSONTyped(json, false);
}

export function AdvertisingCategoryDimensionRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingCategoryDimensionRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'dimension': json['dimension'] == null ? undefined : json['dimension'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function AdvertisingCategoryDimensionRowDataToJSON(json: any): AdvertisingCategoryDimensionRowData {
    return AdvertisingCategoryDimensionRowDataToJSONTyped(json, false);
}

export function AdvertisingCategoryDimensionRowDataToJSONTyped(value?: AdvertisingCategoryDimensionRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'dimension': value['dimension'],
        'campaignCount': value['campaignCount'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'financeScope': value['financeScope'],
    };
}

